import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentExceptionTypes } from './normalize';

export const fetchShipmentExceptionTypes = createProvider(api.fetchShipmentExceptionTypes)
  .andThen((res) => normalizeShipmentExceptionTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
